import { useLog } from '@/utils/logger';

export const LoggerVuexPlugin = store => {
  store.$log = useLog;
};
